// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__GVsIX","menu":"sidebar_menu__alYkV","currentPlan":"sidebar_currentPlan__IpQqq"};